import React from 'react';
import * as PropTypes from 'prop-types';
import { styled } from '@linaria/react';
import { COLORS } from '@livecommerce/design-system';
import { Text } from '@bambuser-ui';
import { getInitials } from 'helpers/initials.js';

const Container = styled.div`
  min-height: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  max-height: ${(props) => props.size}px;
  max-width: ${(props) => props.size}px;
  border-radius: ${(props) => props.borderRadius}px;
  background-color: ${(props) => props.backgroundColor};
  background-image: ${(props) => props.imageUrl || 'none'};
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: ${(props) => props.fontSize}px;
    color: ${(props) => props.color};
    font-weight: 500;
    margin: 0;
    line-height: 100%;
  }
`;

const Avatar = ({
  title = '',
  colorSetId = null,
  imageUrl = null,
  size = 'small',
  numberOfInitials = 1,
  abbreviated = true,
  ...restProps
}) => {
  return (
    <Container
      {...(ColorSets[colorSetId] || DefaultColors )}
      {...(!!imageUrl && { imageUrl: `url(${imageUrl})` })}
      {...Sizes[size]}
      {...restProps}
    >
      {!imageUrl && (
        <Text>{abbreviated ? getInitials(title, numberOfInitials) : title}</Text>
      )}
    </Container>
  );
};

export const ColorSets = {
  1: {
    backgroundColor: COLORS.red_400,
    color: COLORS.dark_500,
  },
  2: {
    backgroundColor: COLORS.yellow_400,
    color: COLORS.dark_500,
  },
  3: {
    backgroundColor: COLORS.green_400,
    color: COLORS.dark_500,
  },
  4: {
    backgroundColor: COLORS.blue_400,
    color: COLORS.dark_500,
  },
  5: {
    backgroundColor: COLORS.purple_400,
    color: COLORS.dark_500,
  },
  6: {
    backgroundColor: COLORS.red_500,
    color: COLORS.light_000,
  },
  7: {
    backgroundColor: COLORS.yellow_500,
    color: COLORS.dark_500,
  },
  8: {
    backgroundColor: COLORS.green_500,
    color: COLORS.light_000,
  },
  9: {
    backgroundColor: COLORS.blue_500,
    color: COLORS.light_000,
  },
  10: {
    backgroundColor: COLORS.purple_500,
    color: COLORS.light_000,
  },
  11: {
    backgroundColor: COLORS.red_600,
    color: COLORS.light_000,
  },
  12: {
    backgroundColor: COLORS.yellow_600,
    color: COLORS.dark_500,
  },
  13: {
    backgroundColor: COLORS.green_600,
    color: COLORS.light_000,
  },
  14: {
    backgroundColor: COLORS.blue_600,
    color: COLORS.light_000,
  },
  15: {
    backgroundColor: COLORS.purple_600,
    color: COLORS.light_000,
  },
  16: {
    backgroundColor: COLORS.red_700,
    color: COLORS.light_000,
  },
  17: {
    backgroundColor: COLORS.yellow_700,
    color: COLORS.light_000,
  },
  18: {
    backgroundColor: COLORS.green_700,
    color: COLORS.light_000,
  },
  19: {
    backgroundColor: COLORS.blue_700,
    color: COLORS.light_000,
  },
  20: {
    backgroundColor: COLORS.purple_700,
    color: COLORS.light_000,
  },
  21: {
    backgroundColor: COLORS.red_800,
    color: COLORS.light_000,
  },
  22: {
    backgroundColor: COLORS.yellow_800,
    color: COLORS.light_000,
  },
  23: {
    backgroundColor: COLORS.green_800,
    color: COLORS.light_000,
  },
  24: {
    backgroundColor: COLORS.blue_800,
    color: COLORS.light_000,
  },
  25: {
    backgroundColor: COLORS.purple_800,
    color: COLORS.light_000,
  },
};

const DefaultColors = {
  backgroundColor: COLORS.dark_500,
  color: COLORS.white,
};

const Sizes = {
  small: {
    size: 36,
    fontSize: 14,
    borderRadius: 8,
  },
  medium: {
    size: 44,
    fontSize: 18,
    borderRadius: 6,
  },
  large: {
    size: 48,
    fontSize: 22,
    borderRadius: 8,
  },
};

export const amountOfColorSets = Object.keys(ColorSets).length;

export default Avatar;

Avatar.propTypes = {
  numberOfInitials: PropTypes.number,
  colorSetId: PropTypes.oneOf(Object.keys(ColorSets).map(Number)),
  title: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(Sizes)),
  imageUrl: PropTypes.string,
  abbreviated: PropTypes.bool,
};
